import type { Permission } from './Permission'

export enum PdvPermissionDomain {
  // Domínios principais do PDV
  POINT_OF_SALE = 'point_of_sale',
  TABLE_SERVICE = 'table_service',
  SALES = 'sales',
  CUSTOMERS = 'customers',
  FINANCIAL = 'financial',
  SETTINGS = 'settings',
  STOCK = 'stock',
  UNKNOWN = 'unknown'
}

export enum PdvPermissionSubDomain {
  // Point of Sale
  POS = 'pos',

  // Table Service
  ATTENDANCE = 'attendance',
  ATTENDANCE_OPERATIONS = 'attendance_operations',
  ATTENDANCE_PAYMENT = 'attendance_payment',

  // Sales
  SALES_OPERATIONS = 'sales_operations',
  SALES_DISCOUNT = 'sales_discount',
  SALES_PAYMENT = 'sales_payment',
  SALES_VIEWING = 'sales_viewing',

  // Customers
  CUSTOMER_CREDIT = 'customer_credit',
  CUSTOMER_BILLING = 'customer_billing',

  // Financial
  CASH_OPERATIONS = 'cash_operations',

  // Settings
  GENERAL = 'general',
  ADMINISTRATIVE = 'administrative',
  SECURITY = 'security',

  // Stock
  CONSIGNMENT = 'consignment',

  // Fallback
  GENERAL_PDV = 'general_pdv'
}

// Mapeamento de domínio principal -> subdomínios
export const PDV_PERMISSION_DOMAIN_MAPPING = {
  [PdvPermissionDomain.POINT_OF_SALE]: [PdvPermissionSubDomain.POS],
  [PdvPermissionDomain.TABLE_SERVICE]: [PdvPermissionSubDomain.ATTENDANCE, PdvPermissionSubDomain.ATTENDANCE_OPERATIONS, PdvPermissionSubDomain.ATTENDANCE_PAYMENT],
  [PdvPermissionDomain.SALES]: [PdvPermissionSubDomain.SALES_OPERATIONS, PdvPermissionSubDomain.SALES_DISCOUNT, PdvPermissionSubDomain.SALES_PAYMENT, PdvPermissionSubDomain.SALES_VIEWING],
  [PdvPermissionDomain.CUSTOMERS]: [PdvPermissionSubDomain.CUSTOMER_CREDIT, PdvPermissionSubDomain.CUSTOMER_BILLING],
  [PdvPermissionDomain.FINANCIAL]: [PdvPermissionSubDomain.CASH_OPERATIONS],
  [PdvPermissionDomain.SETTINGS]: [PdvPermissionSubDomain.GENERAL, PdvPermissionSubDomain.ADMINISTRATIVE, PdvPermissionSubDomain.SECURITY],
  [PdvPermissionDomain.STOCK]: [PdvPermissionSubDomain.CONSIGNMENT]
}

// Labels dos domínios principais (em inglês para tradução na view)
export const PDV_PERMISSION_DOMAIN_LABELS = {
  [PdvPermissionDomain.POINT_OF_SALE]: 'Point of Sale',
  [PdvPermissionDomain.TABLE_SERVICE]: 'Table Service',
  [PdvPermissionDomain.SALES]: 'Sales',
  [PdvPermissionDomain.CUSTOMERS]: 'Customers',
  [PdvPermissionDomain.FINANCIAL]: 'Financial',
  [PdvPermissionDomain.SETTINGS]: 'Settings',
  [PdvPermissionDomain.STOCK]: 'Stock',
  [PdvPermissionDomain.UNKNOWN]: 'Others'
}

// Labels dos subdomínios (em inglês para tradução na view)
export const PDV_PERMISSION_SUBDOMAIN_LABELS = {
  [PdvPermissionSubDomain.POS]: 'POS',
  [PdvPermissionSubDomain.ATTENDANCE]: 'Table Attendance',
  [PdvPermissionSubDomain.ATTENDANCE_OPERATIONS]: 'Attendance Operations',
  [PdvPermissionSubDomain.ATTENDANCE_PAYMENT]: 'Attendance Payment',
  [PdvPermissionSubDomain.SALES_OPERATIONS]: 'Sales Operations',
  [PdvPermissionSubDomain.SALES_DISCOUNT]: 'Sales Discount',
  [PdvPermissionSubDomain.SALES_PAYMENT]: 'Sales Payment',
  [PdvPermissionSubDomain.SALES_VIEWING]: 'Sales Viewing',
  [PdvPermissionSubDomain.CUSTOMER_CREDIT]: 'Customer Credit',
  [PdvPermissionSubDomain.CUSTOMER_BILLING]: 'Customer Billing',
  [PdvPermissionSubDomain.CASH_OPERATIONS]: 'Cash Operations',
  [PdvPermissionSubDomain.GENERAL]: 'General',
  [PdvPermissionSubDomain.ADMINISTRATIVE]: 'Administrative',
  [PdvPermissionSubDomain.SECURITY]: 'Security',
  [PdvPermissionSubDomain.CONSIGNMENT]: 'Consignment',
  [PdvPermissionSubDomain.GENERAL_PDV]: 'General PDV'
}

export interface PdvPermission extends Permission<PdvPermissionDomain, PdvPermissionSubDomain> {}

export interface PdvPermissionSubGroup {
  subDomain: PdvPermissionSubDomain
  label: string
  permissions: PdvPermission[]
}

export interface PdvPermissionGroup {
  domain: PdvPermissionDomain
  label: string
  permissions: PdvPermission[]
  subGroups?: PdvPermissionSubGroup[]
}
